import React, { useEffect, useState } from "react";
import Select from "react-select";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import Utils from "../../common/manipurCommon/Utils";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import { Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const AssessmentReport = () => {

    const [stateList, setStateList] = useState<any[]>([]);
    const [districtList, setDistrictList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [assessmentList, setAssessmentList] = useState<any[]>([]);
    const [coachList, setCoachList] = useState<any[]>([]);
    const [sportList, setSportList] = useState<any[]>([]);
    const [batchList, setBatchList] = useState<any[]>([]);
    const [stateId, setStateId] = useState("");
    const [districtId, setDistrictId] = useState("");
    const [cityId, setCityId] = useState("");
    const [centerId, setCenterId] = useState("");
    const [coachId, setCoachId] = useState("");
    const [sportId, setSportId] = useState("");
    const [batchId, setBatchId] = useState("");
    const [searchInput, setSearchInput] = useState("");
    const [showTable, setShowTable] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        async function fetchInitial() {
            setIsLoading(true);
            const statesResponse = await func.listGeoCenters();
            setCenterList(Array.isArray(statesResponse) ? statesResponse : [])
            setIsLoading(false);
        }
        fetchInitial();
    }, [])

    const filteredData = assessmentList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.batchName}</span>
    };

    const criteriaNameRender = (rowData) => {
        return <span>{rowData.talentScoutingSelectionCriteriaName}</span>
    };

    const coachNameRender = (rowData) => {
        return <span>{rowData.coach}</span>
    };

    const sportsNameRender = (rowData) => {
        return <span>{rowData.sportsName}</span>
    };

    const geoCenterNameRender = (rowData) => {
        return <span>{rowData.geoCenterName}</span>
    };

    const scheduleDateRender = (rowData) => {
        return <span>{rowData.scheduleDate}</span>
    };

    const startTimeRender = (rowData) => {
        return <span>{rowData.scheduleStartTime}</span>
    };

    const endTimeRender = (rowData) => {
        return <span>{rowData.scheduleEndTime}</span>
    }

    function scheduleReport() {
        const compRpt = api.AssessmentReport + '/' + batchId + '/' + sportId + '/' + centerId + '/' + 2;
        fetch(compRpt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    setAssessmentList(result.data)
                    setShowTable(true)
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire(result.message)
                    setShowTable(false)
                }
            })
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1380px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Assessment Report</h4>
                                </div>
                                <hr className="mb-10" />
                            </div>
                            <div className="row">
                                {/* <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">State</label>
                                        <Select
                                            value={stateList.find(state => state.geographyId === stateId) ? {
                                                value: stateId,
                                                label: stateList.find(state => state.geographyId === stateId).geographyName
                                            } : null}
                                            onChange={async (e) => {
                                                setStateId(e.value);
                                                const distResponse = await func.listGeoDistrictByStateId(e?.value);
                                                setDistrictList(Array.isArray(distResponse) ? distResponse : [])
                                            }}
                                            required
                                            placeholder="Select State"
                                            options={stateList.map(state => ({
                                                value: state.geographyId,
                                                label: state.geographyName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">District</label>
                                        <Select
                                            value={districtList.find(district => district.geoDistrictsId === districtId) ? {
                                                value: districtId,
                                                label: districtList.find(district => district.geoDistrictsId === districtId).geoDistrictsName
                                            } : null}
                                            onChange={async (e) => {
                                                setDistrictId(e.value);
                                                const cityResponse = await func.listGeoCityByDistrictId(e?.value);
                                                setCityList(Array.isArray(cityResponse) ? cityResponse : [])
                                            }}
                                            required
                                            placeholder="Select District"
                                            options={districtList.map(district => ({
                                                value: district.geoDistrictsId,
                                                label: district.geoDistrictsName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">City</label>
                                        <Select
                                            value={cityList.find(city => city.geoCityId === cityId) ? {
                                                value: cityId,
                                                label: cityList.find(city => city.geoCityId === cityId).geoCityName
                                            } : null}
                                            onChange={async (e) => {
                                                setCityId(e.value);
                                                const cntrResponse = await func.listGeoCentersByCityId(e?.value);
                                                setCenterList(Array.isArray(cntrResponse) ? cntrResponse : [])
                                            }}
                                            required
                                            placeholder="Select City"
                                            options={cityList.map(city => ({
                                                value: city.geoCityId,
                                                label: city.geoCityName
                                            }))}>
                                        </Select>
                                    </div>
                                </div> */}
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Center</label>
                                        <Select
                                            value={centerList.find(center => center.geoCenterId === centerId) ? {
                                                value: centerId,
                                                label: centerList.find(center => center.geoCenterId === centerId).geoCenterName
                                            } : null}
                                            onChange={async (e) => {
                                                setCenterId(e.value);
                                                const btchResponse = await func.listBatches();
                                                setBatchList(Array.isArray(btchResponse) ? btchResponse : [])
                                                const cochResponse = await func.coachByCenter(e.value);
                                                setCoachList(Array.isArray(cochResponse) ? cochResponse : [])
                                            }}
                                            required
                                            placeholder="Select Center"
                                            options={centerList.map(center => ({
                                                value: center.geoCenterId,
                                                label: center.geoCenterName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Coach</label>
                                        <Select
                                            value={coachList.find(coch => coch.userId === coachId) ? {
                                                value: coachId,
                                                label: coachList.find(coch => coch.userId === coachId).coachName
                                            } : null}
                                            onChange={async (e) => {
                                                setCoachId(e.value);
                                                const sprtResponse = await func.sportByCoachId(e.value);
                                                setSportList(Array.isArray(sprtResponse) ? sprtResponse : [])
                                            }}
                                            required
                                            placeholder="Select Coach"
                                            options={coachList.map(coch => ({
                                                value: coch.userId,
                                                label: coch.coachName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Batch</label>
                                        <Select
                                            value={batchList.find(btch => btch.batchId === batchId) ? {
                                                value: batchId,
                                                label: batchList.find(btch => btch.batchId === batchId).batchName
                                            } : null}
                                            onChange={async (e) => {
                                                setBatchId(e.value);
                                            }}
                                            required
                                            placeholder="Select Batch"
                                            options={batchList.map(btch => ({
                                                value: btch.batchId,
                                                label: btch.batchName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3 mb-10">
                                    <div className="input-space">
                                        <label className="form-label">Sport</label>
                                        <Select
                                            value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                                value: sportId,
                                                label: sportList.find(sprt => sprt.sportId === sportId).sportsName
                                            } : null}
                                            onChange={async (e) => {
                                                setSportId(e.value);
                                            }}
                                            required
                                            placeholder="Select Sport"
                                            options={sportList.map(sprt => ({
                                                value: sprt.sportId,
                                                label: sprt.sportsName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-end">
                                <div className="col-lg-2 col-sm-12 mb-2">
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        onClick={scheduleReport}
                                        className="w-100"
                                    >
                                        Submit
                                    </Button>
                                </div>

                                {/* <div className="col-lg-2 col-sm-12 mb-2">
                                    <Button
                                        type="button"
                                        variant="secondary"
                                        // onClick={exportToExcel} // ✅ Uncomment when function is ready
                                        className="w-100"
                                    >
                                        Export to Excel
                                    </Button>
                                </div> */}
                            </div>
                            <hr className="mb-10" />
                            {showTable && (
                                <div className="tab-content">
                                    <div className="col-lg-12 col-sm-12 mb-10 text-end dataTables_filter">
                                        <label>
                                            <input
                                                type="text"
                                                value={searchInput}
                                                onChange={(e) => setSearchInput(e.target.value)}
                                                style={{ height: "40px" }}
                                                placeholder="Search"
                                                className="form-control"
                                            />
                                        </label>
                                    </div>
                                    <div
                                        className="tab-pane fade show active"
                                        id="nav-Recent"
                                        role="tabpanel"
                                        aria-labelledby="nav-Recent-tab"
                                        tabIndex={0}
                                    >
                                        <div className="table-responsive table-datatble">
                                            <DataTable
                                                className="table datatable"
                                                value={filteredData}
                                                paginator
                                                rows={10}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                pageLinkSize={3}
                                            >
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="slNo"
                                                    body={slNoRender}
                                                    header="Sl &nbsp; No"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="batchName"
                                                    header="Batch Name"
                                                    body={batchNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="coach"
                                                    header="Coach Name"
                                                    body={coachNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="talentScoutingSelectionCriteriaName"
                                                    header="Criteria Name"
                                                    body={criteriaNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="sportsName"
                                                    header="Sport Name"
                                                    body={sportsNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="geoCenterName"
                                                    header="Center Name"
                                                    body={geoCenterNameRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="scheduleDate"
                                                    header="Schedule Date"
                                                    body={scheduleDateRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="scheduleStartTime"
                                                    header="Start Time"
                                                    body={startTimeRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                                <Column
                                                    sortable
                                                    headerClassName="text-uppercase"
                                                    field="scheduleEndTime"
                                                    header="End Time"
                                                    body={endTimeRender}
                                                    className="table-inset-btn"
                                                ></Column>
                                            </DataTable>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default AssessmentReport;